import { InProductTrialTypeEnum } from '@nirvana/shared/dtos/types/in-product-trials';

// main products
export type AvailableMainProductTrialType =
  | InProductTrialTypeEnum.OfficeSecurityPack
  | InProductTrialTypeEnum.NextGen
  | InProductTrialTypeEnum.NextGenWithReconfigurePopup
  | InProductTrialTypeEnum.Atd
  | InProductTrialTypeEnum.XdrFull
  | InProductTrialTypeEnum.XdrSensors;
export const isMainProduct: { [type in AvailableMainProductTrialType]: boolean } = {
  [InProductTrialTypeEnum.OfficeSecurityPack]: true,
  [InProductTrialTypeEnum.NextGen]: true,
  [InProductTrialTypeEnum.NextGenWithReconfigurePopup]: true,
  [InProductTrialTypeEnum.Atd]: true,
  [InProductTrialTypeEnum.XdrFull]: true,
  [InProductTrialTypeEnum.XdrSensors]: true,
};

// security products and addons
export type AvailableSecondaryProductTrialType =
  | InProductTrialTypeEnum.PatchManagement
  | InProductTrialTypeEnum.VolumeEncryption
  | InProductTrialTypeEnum.MobileSecurity
  | InProductTrialTypeEnum.IntegrityMonitor
  | InProductTrialTypeEnum.ContainerProtection
  | InProductTrialTypeEnum.StorageProtection
  | InProductTrialTypeEnum.MdrEnterprise
  | InProductTrialTypeEnum.Cws
  | InProductTrialTypeEnum.ThreatIntel
  | InProductTrialTypeEnum.NadAndEraAddon
  | InProductTrialTypeEnum.WebAccessAndDeviceControlAddon
  | InProductTrialTypeEnum.ComplianceManager;

// all available product trials
export type AvailableProductTrialType = AvailableMainProductTrialType | AvailableSecondaryProductTrialType;
// frontend order for main and secondary products
export const AvailableProductTrialTypesOrder: { [type in AvailableProductTrialType]: number } = {
  [InProductTrialTypeEnum.OfficeSecurityPack]: 0,
  [InProductTrialTypeEnum.NextGenWithReconfigurePopup]: 1,
  [InProductTrialTypeEnum.NextGen]: 2,
  [InProductTrialTypeEnum.Atd]: 3,
  [InProductTrialTypeEnum.XdrFull]: 4,
  [InProductTrialTypeEnum.XdrSensors]: 5,
  [InProductTrialTypeEnum.PatchManagement]: 6,
  [InProductTrialTypeEnum.VolumeEncryption]: 7,
  [InProductTrialTypeEnum.MobileSecurity]: 8,
  [InProductTrialTypeEnum.IntegrityMonitor]: 9,
  [InProductTrialTypeEnum.ContainerProtection]: 10,
  [InProductTrialTypeEnum.StorageProtection]: 11,
  [InProductTrialTypeEnum.MdrEnterprise]: 12,
  [InProductTrialTypeEnum.Cws]: 13,
  [InProductTrialTypeEnum.ThreatIntel]: 14,
  [InProductTrialTypeEnum.NadAndEraAddon]: 15,
  [InProductTrialTypeEnum.WebAccessAndDeviceControlAddon]: 16,
  [InProductTrialTypeEnum.ComplianceManager]: 17,
};
